import { render, staticRenderFns } from "./MonologueModule.vue?vue&type=template&id=67118020&scoped=true&"
import script from "./MonologueModule.vue?vue&type=script&lang=js&"
export * from "./MonologueModule.vue?vue&type=script&lang=js&"
import style0 from "./MonologueModule.vue?vue&type=style&index=0&id=67118020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67118020",
  null
  
)

export default component.exports